/**
 * Fixed values of the data model (brief section 3). They are stored in the
 * database and sent to HubSpot, so they never change with configuration;
 * their display labels live in config/portal.json.
 */

/** The four operating markets. The product is a sorting system, never a "cell". */
export const MARKET_CODES = ['WR-1', 'WR-2', 'WR-3', 'WR-4'] as const;
export type MarketCode = (typeof MARKET_CODES)[number];

export const INTEREST_VALUES = ['active', 'browsing'] as const;
export type Interest = (typeof INTEREST_VALUES)[number];

export const ROLE_VALUES = ['decides', 'influences', 'scoping', 'none'] as const;
export type BuyingRole = (typeof ROLE_VALUES)[number];

export const CONTACT_SOURCES = [
  'scan',
  'manual',
  'kiosk_form',
  'kiosk_visitor',
  'hubspot',
] as const;
export type ContactSource = (typeof CONTACT_SOURCES)[number];
